import { render } from "./App.vue?vue&type=template&id=eb6a0822"
const script = {}

import "./App.vue?vue&type=style&index=0&id=eb6a0822&lang=scss"

import exportComponent from "/home/orynik/Documents/source/personal/trainer-blind-print/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__